module.exports = __webpack_public_path__ + "d-6IYplOFocCacKzxwXSOFtXRa8TVwTICgirnJhmVJw.aa3e87117db2b3c27801.woff2";


//////////////////
// WEBPACK FOOTER
// D:/OficinaVirtual/FrontEndFinnecta/EFactoringManager/src/assets/fonts/roboto/d-6IYplOFocCacKzxwXSOFtXRa8TVwTICgirnJhmVJw.woff2
// module id = ../../../../../src/assets/fonts/roboto/d-6IYplOFocCacKzxwXSOFtXRa8TVwTICgirnJhmVJw.woff2
// module chunks = styles